module.exports = new __parcel__URL__("empty.0bf17c37.png").toString();